// Turkish (tr). Keyed by the English source string.
//
// NOT YET REVIEWED by a Turkish speaker -- see locales/index.js. Load it with
// ?lang=tr to read it in place; it is not offered to users until reviewed.
//
// Notes for whoever reviews it: informal "sen" throughout -- Lumi is for
// talking to strangers casually, and "siz" would read like a bank. "Bildir" is
// used for reporting to moderation (not "rapor et", which is officialese).
// Lumi is a brand name and is not declined with an apostrophe in UI labels.
export default {
  // ---- Landing ----
  'Light up a conversation': 'Bir sohbeti aydınlat',
  'Free, anonymous video, audio and text chat. Meet someone new one to one, or open a room and bring your friends.':
    'Ücretsiz ve anonim görüntülü, sesli ve yazılı sohbet. Bire bir yeni biriyle tanış ya da bir oda aç ve arkadaşlarını çağır.',
  'Name (optional)': 'İsim (isteğe bağlı)',
  'Optional: what should people call you?': 'İsteğe bağlı: sana nasıl seslenilsin?',
  'Interests (optional)': 'İlgi alanları (isteğe bağlı)',
  'Optional: interests (e.g. music, hiking, anime)': 'İsteğe bağlı: ilgi alanları (örn. müzik, doğa yürüyüşü, anime)',
  'Birth year': 'Doğum yılı',
  'Select year': 'Yıl seç',
  'How do you want to chat?': 'Nasıl sohbet etmek istersin?',
  Camera: 'Kamera',
  'Ready to Chat': 'Sohbete hazırım',
  'Group rooms': 'Grup odaları',
  'Ten minutes': 'On dakika',
  'A chat with a gentle end, with people who chose it too.':
    'Yumuşak biten bir sohbet, bunu seçen kişilerle.',
  About: 'Hakkında',
  Regulars: 'Devamlılar',
  'Your regulars': 'Devamlıların',
  'Watch together': 'Birlikte izle',
  'You are invited to a group room': 'Bir grup odasına davet edildin',
  'You are invited to a community.': 'Bir topluluğa davet edildin.',
  ' Verify your age to ask to join. Its host lets people in when they see the request.':
    ' Katılmak için yaşını doğrula. Sahibi isteği gördüğünde içeri alır.',

  // ---- Chat ----
  Chat: 'Sohbet',
  'Say something nice...': 'Güzel bir şey söyle...',
  'Finding someone new...': 'Yeni biri aranıyor...',
  'Show my camera': 'Kameramı göster',
  'Cameras open when you both tap Show my camera':
    'Kameralar, ikiniz de Kameramı göster’e dokunduğunuzda açılır',
  'Open your camera to them. It opens once they have done the same.':
    'Kameranı ona aç. Karşı taraf da aynısını yaptığında açılır.',
  'Skip to the next person': 'Sonraki kişiye geç',
  'Leave the chat and go back to the homepage': 'Sohbetten çık ve ana sayfaya dön',
  'Report this person': 'Bu kişiyi bildir',
  Report: 'Bildir',
  Wave: 'El salla',
  'Wave at the person you just talked to': 'Az önce konuştuğun kişiye el salla',
  'Go back to that person': 'O kişiye geri dön',
  'Send an image': 'Görsel gönder',
  'Share a photo, video, or audio file': 'Bir fotoğraf, video veya ses dosyası paylaş',
  'Report this file to the Lumi team': 'Bu dosyayı Lumi ekibine bildir',
  Remove: 'Kaldır',
  'Remove this person for 15 minutes (moderator)': 'Bu kişiyi 15 dakikalığına çıkar (moderatör)',
  'You removed this.': 'Bunu kaldırdın.',
  'Take this off your screen': 'Bunu ekranından kaldır',
  'Cancel reply': 'Yanıtı iptal et',
  'A question, if you want one: ': 'İstersen bir soru: ',
  'Dismiss this question': 'Bu soruyu kapat',
  'Double-tap to show the chat and controls': 'Sohbeti ve kontrolleri görmek için iki kez dokun',
  'Not now': 'Şimdi değil',
  'Lumi Staff': 'Lumi Ekibi',
  'LUMI STAFF': 'LUMI EKİBİ',
  'Verified Lumi staff': 'Doğrulanmış Lumi ekibi',
  Moderator: 'Moderatör',
  'Verified moderator': 'Doğrulanmış moderatör',
  'Lumi Plus member': 'Lumi Plus üyesi',
  'Explicit: off': 'Müstehcen: kapalı',
  'Explicit chat (18+)': 'Müstehcen sohbet (18+)',
  'Match me only with adults who chose this too. It changes who you meet next, not this chat, and you both still have to agree once you are in one.':
    'Beni yalnızca bunu seçen yetişkinlerle eşleştir. Bu sohbeti değil, bundan sonra kiminle tanışacağını değiştirir; sohbete girdiğinizde yine ikinizin de kabul etmesi gerekir.',

  // ---- Rooms and communities ----
  ' here': ' burada',
  '<- Back': '<- Geri',
  'A community': 'Bir topluluk',
  'A community is one private room somebody keeps for people they have invited. Lumi stores who is in it and the sessions planned, nothing else.':
    'Topluluk, birinin davet ettiği kişiler için açık tuttuğu tek bir özel odadır. Lumi yalnızca kimlerin içinde olduğunu ve planlanan buluşmaları saklar, başka hiçbir şeyi değil.',
  'A community: a private room its host keeps open for invited members':
    'Bir topluluk: sahibinin davetli üyeler için açık tuttuğu özel bir oda',
  'A shared timer everyone in the room can see': 'Odadaki herkesin görebildiği ortak bir sayaç',
  Accept: 'Kabul et',
  Activities: 'Etkinlikler',
  'Add session': 'Buluşma ekle',
  'Add to calendar': 'Takvime ekle',
  'Always open': 'Her zaman açık',
  'Anyone with the link can verify their age and ask to join. You decide who gets in.':
    'Bağlantıya sahip herkes yaşını doğrulayıp katılmak isteyebilir. Kimin gireceğine sen karar verirsin.',
  'Ask one person who is waiting if they would like to join for ten minutes':
    'Bekleyen bir kişiye on dakikalığına katılmak isteyip istemediğini sor',
  'Ask to chat one-on-one': 'Bire bir sohbet iste',
  'Asked to join': 'Katılmak istedi',
  'Audio room': 'Sesli oda',
  Browse: 'Göz at',
  Close: 'Kapat',
  'Communities you are in': 'Üyesi olduğun topluluklar',
  Community: 'Topluluk',
  'Copy Lumi Link': 'Lumi Link kopyala',
  'Copy my Lumi Link': 'Lumi Link bağlantımı kopyala',
  'Copy the Lumi Link for this room': 'Bu odanın Lumi Link bağlantısını kopyala',
  Create: 'Oluştur',
  'Create one and it will show up here for everyone in your age group.':
    'Bir tane oluştur, yaş grubundaki herkes için burada görünsün.',
  'Create room': 'Oda oluştur',
  Decline: 'Reddet',
  Delete: 'Sil',
  'Download an .ics file for this session': 'Bu buluşma için .ics dosyası indir',
  'Drop in': 'Uğra',
  'Every live room': 'Tüm açık odalar',
  'Every week': 'Her hafta',
  Generate: 'Üret',
  'Go 1:1': 'Bire bir geç',
  'Has hosted rooms people came to': 'İnsanların geldiği odalar açmış',
  'Has not said anything yet': 'Henüz bir şey söylemedi',
  'Have a code?': 'Kodun var mı?',
  'Hide this person: no video, audio, texts, or files from them, and they cannot ask you to go 1:1':
    'Bu kişiyi gizle: ondan görüntü, ses, mesaj veya dosya gelmez ve senden bire bir sohbet isteyemez',
  'Hides it here for now. They are not told, and they can still be accepted later.':
    'Şimdilik burada gizler. Kişiye bildirilmez ve daha sonra yine kabul edilebilir.',
  Ignore: 'Yoksay',
  'Invite a regular...': 'Bir devamlıyı davet et...',
  'Invite someone in': 'Birini davet et',
  Join: 'Katıl',
  'Join as Lumi Staff: you will be visible to the room, wearing the staff badge':
    'Lumi Ekibi olarak katıl: odaya görünür olursun ve ekip rozetini taşırsın',
  'Jump in': 'Hemen katıl',
  Kick: 'At',
  Leave: 'Ayrıl',
  'Leave and block': 'Ayrıl ve engelle',
  'Leave, and block the host: you stop being regulars and they cannot invite you again. They are not told.':
    'Ayrıl ve sahibini engelle: artık devamlı olmazsınız ve seni bir daha davet edemez. Kendisine bildirilmez.',
  'Loading...': 'Yükleniyor...',
  'Lumi keeps the name, the code, who is in, and the sessions. Not the conversation.':
    'Lumi adı, kodu, kimlerin içinde olduğunu ve buluşmaları saklar. Konuşmayı saklamaz.',
  MOD: 'MOD',
  Members: 'Üyeler',
  'Message the room...': 'Odaya yaz...',
  Mute: 'Sesini kapat',
  'My community': 'Topluluğum',
  'New messages': 'Yeni mesajlar',
  'No live rooms right now.': 'Şu anda açık oda yok.',
  'No public rooms right now': 'Şu anda herkese açık oda yok',
  'No session planned.': 'Planlanmış buluşma yok.',
  'Nobody owns these and they never close. Walk in, listen for a while, and say something when you feel like it.':
    'Bunlar kimseye ait değil ve hiç kapanmaz. Gir, bir süre dinle ve canın istediğinde bir şey söyle.',
  'Nobody yet. Invite a regular, or share your Lumi Link.': 'Henüz kimse yok. Bir devamlıyı davet et ya da Lumi Link bağlantını paylaş.',
  Once: 'Bir kez',
  Open: 'Aç',
  'Out of the community: they cannot come back unless you invite them again':
    'Topluluktan çıkar: sen yeniden davet etmedikçe geri gelemez',
  'Out of the room for 15 minutes; still a member': '15 dakika odanın dışında; üyeliği sürüyor',
  PRO: 'PRO',
  'People on camera, out of the camera slots this room has':
    'Kamerası açık kişi sayısı ve bu odadaki kamera yeri sayısı',
  'Pin this for everyone in the room': 'Bunu odadaki herkes için sabitle',
  Private: 'Özel',
  'Public rooms': 'Herkese açık odalar',
  Refresh: 'Yenile',
  Rename: 'Adını değiştir',
  'Room Pro: the larger room': 'Room Pro: geniş oda',
  'Room chat': 'Oda sohbeti',
  'Room code': 'Oda kodu',
  'Room name': 'Oda adı',
  'Room rules': 'Oda kuralları',
  'Rooms that are always open': 'Her zaman açık odalar',
  'Say hi, I have been lurking': 'Selam ver, bir süredir izliyorum',
  See: 'Gör',
  Send: 'Gönder',
  Sessions: 'Buluşmalar',
  'Share a file': 'Dosya paylaş',
  'Sit down to work with a shared timer:': 'Ortak bir sayaçla çalışmaya otur:',
  'Something to do together': 'Birlikte yapılacak bir şey',
  Start: 'Başlat',
  'Start a chat once and Lumi will remember you on this device; then a community can too.':
    'Bir kez sohbet et, Lumi seni bu cihazda hatırlasın; sonra bir topluluk da hatırlayabilir.',
  'Start a community': 'Topluluk kur',
  'Start a room': 'Oda aç',
  'Start my community': 'Topluluğumu kur',
  'Started this room': 'Bu odayı açtı',
  'Straight into one': 'Doğrudan birine',
  'Suggest a name nobody is using': 'Kimsenin kullanmadığı bir ad öner',
  'Take the invitation back': 'Daveti geri al',
  'Talk with a few people at once. Start your own, or drop into one that is already going.':
    'Aynı anda birkaç kişiyle konuş. Kendi odanı aç ya da devam eden birine uğra.',
  'Text room': 'Yazılı oda',
  'The language this room is for': 'Bu odanın dili',
  'They leave the room and cannot come back unless you invite them again':
    'Odadan çıkar ve sen yeniden davet etmedikçe geri gelemez',
  'Times are in your clock. Members see it inside the room and get a reminder ten minutes before, if they are on Lumi then.':
    'Saatler senin saatine göredir. Üyeler odanın içinde görür ve o sırada Lumi’deyseler on dakika önce hatırlatma alır.',
  'Try again': 'Tekrar dene',
  'Video room': 'Görüntülü oda',
  'Vote: go private': 'Oyla: özele geç',
  Waiting: 'Bekliyor',
  'We will find a room of that kind with space in it.': 'O türden, yeri olan bir oda buluruz.',
  'What are you doing?': 'Ne yapıyorsunuz?',
  'What is it? e.g. Film night': 'Nedir? Örn. Film gecesi',
  'Who is in this room': 'Bu odada kimler var',
  Withdraw: 'Geri çek',
  Yes: 'Evet',
  'You can enter any room here, including private ones and the minors band.':
    'Buradan her odaya girebilirsin: özel odalar ve küçükler bandı dahil.',
  'You can invite your regulars once you have some: wave after a chat, and if they wave back, they are here to pick.':
    'Devamlıların olduğunda onları davet edebilirsin: sohbetten sonra el salla, karşı taraf da sallarsa burada seçilmeye hazır olurlar.',
  'You muted this person': 'Bu kişinin sesini kapattın',
  'Your community': 'Topluluğun',
  'Your community code': 'Topluluk kodun',
  'Your status': 'Durumun',
  Yours: 'Seninki',
  'e.g. Late Night Lounge': 'örn. Gece Salonu',
  'e.g. Tuesday book club': 'örn. Salı kitap kulübü',

  // ---- Account, Plus, support, activities, media controls ----
  ' I have written it down or saved it': ' Not aldım ya da kaydettim',
  '(no drawing arrived, so describe what you imagine)': '(çizim gelmedi, aklına geleni anlat)',
  '(nothing arrived in time)': '(zamanında bir şey gelmedi)',
  '+30s': '+30sn',
  'A concern, a bug or a question. It goes straight to the Lumi team. Replies appear here; keep the page open.':
    'Bir endişe, bir hata ya da bir soru. Doğrudan Lumi ekibine gider. Yanıtlar burada görünür; sayfayı açık bırak.',
  'A plausible answer': 'İnandırıcı bir cevap',
  'A regular is someone you have both waved at after a chat. Lumi keeps the two of you, the names you saw, the date, and any messages you send each other for thirty days. Nothing else: no history, and never where anyone was.':
    'Devamlı, bir sohbetin ardından ikinizin de el salladığı kişidir. Lumi ikinizi, gördüğünüz isimleri, tarihi ve birbirinize yazdığınız mesajları otuz gün saklar. Başka hiçbir şeyi: ne geçmişi, ne de kimin nerede olduğunu.',
  'A reviewer would like a brief live camera check to confirm your age. Tap Start when you are ready: they can see and talk to you until the check is decided.':
    'Bir denetleyici yaşını doğrulamak için kısa bir canlı kamera kontrolü istiyor. Hazır olduğunda Başlat’a dokun: karar verilene kadar seni görebilir ve seninle konuşabilir.',
  'A sentence somebody could draw': 'Birinin çizebileceği bir cümle',
  'A short tone when someone joins a room, when a regular is around, when a call comes in, and when a message arrives while you are looking elsewhere.':
    'Biri odaya katıldığında, bir devamlı çevrimiçi olduğunda, bir arama geldiğinde ve sen başka yere bakarken mesaj geldiğinde kısa bir ses.',
  'Add to queue': 'Sıraya ekle',
  'Amount (USD)': 'Tutar (USD)',
  'An account is optional. Lumi works without one. Signing in only remembers your name, your Plus membership, and anything you have unlocked.':
    'Hesap isteğe bağlıdır. Lumi hesapsız da çalışır. Giriş yapmak yalnızca adını, Plus üyeliğini ve açtığın şeyleri hatırlar.',
  'Asking...': 'Soruluyor...',
  Back: 'Geri',
  'Back ten seconds, for everyone': 'Herkes için on saniye geri',
  'Back to Lumi': 'Lumi’ye dön',
  'Back to sign in': 'Girişe dön',
  'Back to start': 'Başa dön',
  'Background blur': 'Arka planı bulanıklaştır',
  Block: 'Engelle',
  Call: 'Ara',
  Cancel: 'Vazgeç',
  'Chat text size': 'Yazı boyutu',
  'Chat with an Admin': 'Bir yöneticiyle konuş',
  Clear: 'Temizle',
  Continue: 'Devam et',
  'Continue without sound': 'Sessiz devam et',
  Cool: 'Soğuk',
  Copy: 'Kopyala',
  'Cosmetics shop': 'Görsel mağaza',
  'Create account': 'Hesap oluştur',
  'Delete this message for everyone': 'Bu mesajı herkes için sil',
  'Delete this message for you': 'Bu mesajı yalnızca kendinden sil',
  'Describe the drawing in a sentence': 'Çizimi bir cümleyle anlat',
  'Dismiss this notice': 'Bu bildirimi kapat',
  Donate: 'Bağış yap',
  'Draw and guess': 'Çiz ve tahmin et',
  'Draw this': 'Bunu çiz',
  Dream: 'Rüya',
  'Each round one person sees the marker and gives one clue. Everyone else guesses where it sits.':
    'Her turda bir kişi işareti görür ve tek bir ipucu verir. Diğerleri nerede olduğunu tahmin eder.',
  'Earlier messages': 'Önceki mesajlar',
  'Eighty seconds a drawing. Three points for the first right guess, then two, then one, and one to the drawer each time.':
    'Çizim başına seksen saniye. İlk doğru tahmine üç puan, sonra iki, sonra bir; her seferinde çizene de bir puan.',
  'End the shared video for everyone': 'Ortak videoyu herkes için bitir',
  'End this activity for everyone': 'Bu etkinliği herkes için bitir',
  Eraser: 'Silgi',
  'Everyone answers, out loud or in the chat. No vote on this one.':
    'Herkes yanıtlar, sesli ya da sohbette. Bunda oylama yok.',
  'Everyone writes a sentence. Each is handed on to be drawn, then described, then drawn again, round the table. Then the album.':
    'Herkes bir cümle yazar. Her biri çizilmek, sonra anlatılmak, sonra yeniden çizilmek üzere sırayla devredilir. Sonunda albüm.',
  FAQ: 'SSS',
  Filter: 'Filtre',
  'Final scores': 'Son puanlar',
  'Forget me on this device': 'Bu cihazda beni unut',
  'Forgot your password?': 'Şifreni mi unuttun?',
  From: 'Kimden',
  'Get Lumi Plus': 'Lumi Plus al',
  'Getting your camera ready...': 'Kameran hazırlanıyor...',
  'Go Plus monthly': 'Aylık Plus',
  'Go Plus yearly': 'Yıllık Plus',
  'Handed in. Waiting for the others.': 'Teslim edildi. Diğerleri bekleniyor.',
  'If you have lost the code as well, an admin can look at it.':
    'Kodu da kaybettiysen bir yönetici bakabilir.',
  'Insert an emoji': 'Emoji ekle',
  Invisible: 'Görünmez',
  'Join them': 'Ona katıl',
  'Keep an independent, ad-free, privacy-first service alive. Thank you.':
    'Bağımsız, reklamsız ve gizliliği önceleyen bir hizmeti ayakta tut. Teşekkürler.',
  'Larger chat text': 'Daha büyük yazı',
  'Line this up to play after what is on now': 'Şu an oynayanın ardından çalması için sıraya al',
  'Live check requested': 'Canlı kontrol istendi',
  'Live: ten questions, fifteen seconds each. Fake answer: write something plausible, then vote; you score for finding the truth and for fooling people.':
    'Canlı: on soru, her biri on beş saniye. Sahte cevap: inandırıcı bir şey yaz, sonra oy ver; doğruyu bulunca ve başkalarını kandırınca puan alırsın.',
  'Load and watch': 'Yükle ve izle',
  'Lumi Plus and more': 'Lumi Plus ve dahası',
  'Lumi admin': 'Lumi yöneticisi',
  'Lumi is free and ad-free. Upgrades are optional and 18+ only. Under-18 accounts cannot be created.':
    'Lumi ücretsiz ve reklamsızdır. Yükseltmeler isteğe bağlıdır ve yalnızca 18 yaş üstü içindir. 18 yaş altı hesap açılamaz.',
  'Lumi remembers you on this device with a random key, so regulars and rooms can find you again. It holds no name and no personal details, and it is deleted after 90 days away.':
    'Lumi seni bu cihazda rastgele bir anahtarla hatırlar; böylece devamlıların ve odalar seni yeniden bulabilir. İçinde ad ya da kişisel bilgi yoktur ve 90 gün uğramazsan silinir.',
  'Make it sound true. Nobody sees who wrote what until the end.':
    'Gerçek gibi göstermeye çalış. Sonuna kadar kimin ne yazdığını kimse görmez.',
  'Message deleted': 'Mesaj silindi',
  'Message from the review team': 'Denetim ekibinden mesaj',
  'Messages here go only to Lumi administrators. A live voice/video chat starts only if you tap Start.':
    'Buraya yazdıkların yalnızca Lumi yöneticilerine gider. Canlı sesli/görüntülü sohbet yalnızca Başlat’a dokunursan başlar.',
  Mono: 'Mono',
  Monthly: 'Aylık',
  'More than half of the people here can skip what is on':
    'Buradakilerin yarısından fazlası oynayanı atlayabilir',
  'New password (8+ characters)': 'Yeni şifre (8+ karakter)',
  'Nice!': 'Güzel!',
  'No answer.': 'Yanıt yok.',
  'No filter': 'Filtre yok',
  'No points yet.': 'Henüz puan yok.',
  'No regulars yet.': 'Henüz devamlı yok.',
  'No thanks': 'Hayır, teşekkürler',
  'Noise suppression': 'Gürültü engelleme',
  'Not open yet': 'Henüz açık değil',
  'Not open yet. ': 'Henüz açık değil. ',
  'Nothing is remembered on this device yet.': 'Bu cihazda henüz hiçbir şey hatırlanmıyor.',
  'One clue, a word or two': 'Tek ipucu, bir iki kelime',
  'One of these is true. Which?': 'Bunlardan biri doğru. Hangisi?',
  'One person tells three things about themselves, two true and one made up. Everyone else votes for the lie.':
    'Bir kişi kendisi hakkında üç şey söyler; ikisi doğru, biri uydurma. Diğerleri yalan olana oy verir.',
  'Only you can see the marker. Say one thing that sits about here.':
    'İşareti yalnızca sen görüyorsun. Aşağı yukarı buraya denk gelen bir şey söyle.',
  'Password (8+ characters)': 'Şifre (8+ karakter)',
  'Paste a link': 'Bir bağlantı yapıştır',
  'People you have both waved at after a chat. You stay anonymous to each other.':
    'Bir sohbetin ardından ikinizin de el salladığı kişiler. Birbirinize karşı anonim kalırsınız.',
  'Pick up': 'Aç',
  'Plus is not on sale yet: these are the planned prices. Lumi is free and complete without it, and your account is ready for the day it opens.':
    'Plus henüz satışta değil: bunlar planlanan fiyatlar. Lumi onsuz da ücretsiz ve eksiksizdir; hesabın açıldığı gün için hazır olacak.',
  Points: 'Puan',
  'Priority matching, higher video quality, and exclusive cosmetics are now yours. Enjoy!':
    'Öncelikli eşleşme, daha yüksek görüntü kalitesi ve özel görseller artık senin. İyi eğlenceler!',
  'Priority queue, a higher video bitrate, cosmetic flair, and a Plus mark. No ads, no data sale, ever.':
    'Öncelikli sıra, daha yüksek görüntü kalitesi, görsel ayrıcalıklar ve Plus işareti. Reklam yok, veri satışı yok, hiçbir zaman.',
  'Question cards': 'Soru kartları',
  'Quiet hours': 'Sessiz saatler',
  React: 'Tepki ver',
  'React to this message': 'Bu mesaja tepki ver',
  Ready: 'Hazır',
  'Recovery code from signup': 'Kayıttan gelen kurtarma kodu',
  'Remove them from your regulars. They are not told.':
    'Onu devamlılarından çıkar. Kendisine bildirilmez.',
  Reply: 'Yanıtla',
  'Reply to this message': 'Bu mesajı yanıtla',
  'Report this message to the Lumi team': 'Bu mesajı Lumi ekibine bildir',
  'Report to an admin': 'Bir yöneticiye bildir',
  'Ringing...': 'Çalıyor...',
  'Room Pro': 'Room Pro',
  Scores: 'Puanlar',
  'Send to an admin': 'Bir yöneticiye gönder',
  'Set a new password': 'Yeni bir şifre belirle',
  Settings: 'Ayarlar',
  'Sign in': 'Giriş yap',
  'Sign in or create an account (18+) to go Plus, upgrade a room, or grab cosmetics. Lumi stays free either way.':
    'Plus’a geçmek, bir odayı yükseltmek ya da görseller almak için giriş yap veya hesap oluştur (18+). Lumi her hâlükârda ücretsiz kalır.',
  'Sign out': 'Çıkış yap',
  'Signing in is instant. Creating an account is 18+ and includes a quick age check.':
    'Giriş yapmak anında olur. Hesap açmak 18 yaş üstü içindir ve kısa bir yaş kontrolü içerir.',
  'Skip forward thirty seconds, for everyone': 'Herkes için otuz saniye ileri',
  'Smaller chat text': 'Daha küçük yazı',
  'Something drawable: one or two things, one action, one twist.':
    'Çizilebilir bir şey: bir iki nesne, bir eylem, bir sürpriz.',
  Sounds: 'Sesler',
  Spectrum: 'Skala',
  'Start live chat': 'Canlı sohbeti başlat',
  'Start live check': 'Canlı kontrolü başlat',
  Stop: 'Durdur',
  'Support Lumi': 'Lumi’ye destek ol',
  Telephone: 'Telefon',
  Text: 'Yazı',
  'The admin wants to talk live': 'Yönetici canlı konuşmak istiyor',
  'The code you were given when you created the account.':
    'Hesabı oluştururken sana verilen kod.',
  'The game is under way.': 'Oyun sürüyor.',
  'The word was': 'Kelime şuydu',
  'They are not free right now.': 'Şu anda müsait değil.',
  'They did not pick up.': 'Açmadı.',
  'This device': 'Bu cihaz',
  'This game runs inside a Lumi room.': 'Bu oyun bir Lumi odasının içinde oynanır.',
  'This will not play here': 'Bu burada oynatılamaz',
  Trivia: 'Bilgi yarışması',
  'Turn on camera': 'Kamerayı aç',
  'Turn on microphone': 'Mikrofonu aç',
  'Two ways to play': 'İki oynayış biçimi',
  'Type a message...': 'Bir mesaj yaz...',
  'Type your reply...': 'Yanıtını yaz...',
  'Unpin it': 'Sabitlemeyi kaldır',
  'Upgrade room': 'Odayı yükselt',
  'Use your recovery code': 'Kurtarma kodunu kullan',
  Username: 'Kullanıcı adı',
  'Vanity code (e.g. LOUNGE)': 'Özel kod (örn. SALON)',
  'Verifying your age': 'Yaşın doğrulanıyor',
  Video: 'Görüntü',
  Voice: 'Ses',
  'Voice and video, so you can talk directly. Nothing starts until you tap.':
    'Doğrudan konuşabilmen için ses ve görüntü. Sen dokunmadan hiçbir şey başlamaz.',
  'Waiting for the room...': 'Oda bekleniyor...',
  Warm: 'Sıcak',
  'What is this?': 'Bu nedir?',
  'What would you like to tell us?': 'Bize ne anlatmak istersin?',
  'When a chat ends you can wave. If the other person waves too, within seven days, you become regulars: you see each other here, and which public room the other is in. Nobody is told about a wave that was not returned.':
    'Bir sohbet bitince el sallayabilirsin. Karşı taraf da yedi gün içinde el sallarsa devamlı olursunuz: birbirinizi burada görürsünüz ve diğerinin hangi açık odada olduğunu bilirsiniz. Karşılıksız kalan bir selam kimseye bildirilmez.',
  'Whether everyone may play and pause. Seeking and stopping stay yours either way.':
    'Herkesin oynatıp duraklatabilmesi. İleri sarma ve durdurma her hâlükârda sende kalır.',
  Whiteboard: 'Beyaz tahta',
  'Who is playing': 'Kimler oynuyor',
  'Would you rather...': 'Hangisini seçerdin...',
  'Write a message': 'Bir mesaj yaz',
  'Write a sentence': 'Bir cümle yaz',
  'Write this down before you continue': 'Devam etmeden önce bunu not al',
  Yearly: 'Yıllık',
  'You are a Plus member. Thank you for keeping Lumi independent and ad-free.':
    'Plus üyesisin. Lumi’yi bağımsız ve reklamsız tuttuğun için teşekkürler.',
  'You got it! Watch the others try.': 'Bildin! Şimdi diğerlerini izle.',
  'You have been given Lumi Plus!': 'Sana Lumi Plus verildi!',
  'You joined after it started, so you get to watch the album at the end.':
    'Başladıktan sonra katıldın, bu yüzden sonunda albümü izleyeceksin.',
  'Your Lumi account': 'Lumi hesabın',
  'Your answer is in.': 'Yanıtın alındı.',
  'Your guess': 'Tahminin',
  'Your microphone level (scaled by the volume slider)':
    'Mikrofon seviyen (ses kaydırıcısına göre ölçeklenir)',
  'Your regulars will not see which room you are in, or that you are here at all.':
    'Devamlıların hangi odada olduğunu, hatta burada olduğunu bile görmez.',
  'Your turn to draw. Pick a word:': 'Çizme sırası sende. Bir kelime seç:',
  'Your turn: give one clue': 'Sıra sende: bir ipucu ver',
  // A brand name: the same in every language. Listed so it reads as a
  // decision rather than a gap in the catalog.
  'Lumi Plus': 'Lumi Plus',
  'Audio': 'Sesli',
  'Opens when we both agree': 'İkimiz de kabul edince açılır',
  'Opens from the start': 'Baştan açık',
  'Your account': 'Hesabın',
  'Sign in or create an account': 'Giriş yap ya da hesap oluştur',
  'Create account (18+)': 'Hesap oluştur (18+)',
  'Regulars ({n})': 'Devamlılar ({n})',
};
